import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { DetailsPage } from './DetailsPage'
import { HomePage } from './HomePage'
import { useEffect, useState } from 'react'
import { LoginDialog } from '../dialogs/LoginDialog'
import { DashboardPage } from './dashboard/DashboardPage'
import { useAuthStore } from '../data/useAuthStore'
import { SubmitPage } from './submit/SubmitPage'
import { BlogEditorPage } from './blog/BlogEditorPage'
import { BlogPostPage } from './blog/BlogPostPage'
import { BlogPage } from './blog/BlogPage'
import { NotFoundPage } from './NotFoundPage'
import { FragFinderHeading } from '../components/FragFinderHeading'
import { Transition } from '@headlessui/react'

export const RootPage = () => {
  const { initializeAuth, isInitializing } = useAuthStore()
  const [showLoading, setShowLoading] = useState(true)

  useEffect(() => {
    initializeAuth()
  }, [])

  // When auth finishes initializing, trigger fade out
  useEffect(() => {
    if (!isInitializing) {
      // Small delay to ensure smooth transition
      const timer = setTimeout(() => {
        setShowLoading(false)
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [isInitializing])

  return (
    <>
      {/* Loading screen with fade-out transition */}
      <Transition
        show={showLoading}
        leave="transition-opacity duration-500"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 min-h-screen flex flex-col items-center justify-center bg-background z-50">
          <FragFinderHeading text="FragFinder" className="md:text-4xl text-2xl leading-normal" />
          <div className="text-2xl text-gray-600 mt-8">Loading...</div>
        </div>
      </Transition>

      {/* Main app content */}
      {!isInitializing && (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/dashboard/:view?" element={<DashboardPage />} />
            <Route path="/submit" element={<SubmitPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/editor" element={<BlogEditorPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/fragrance/:slug" element={<DetailsPage />} />
            <Route path="/login" element={<LoginDialog />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      )}
    </>
  )
}
